export default "__VITE_ASSET__CVJhGJ0$__"